import React from 'react';
import { ASSETS } from '../mock';

const HowItWorks = () => {
  return (
    <section className="relative bg-white py-24 px-6 md:px-12 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-fnl-pink font-semibold text-sm tracking-wider uppercase mb-3">How it works</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            Have fun with Flirty
          </h2>
        </div>

        {/* Row 1 - Browse members */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-24">
          <div className="relative card-hover">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-pink-50 to-purple-50 p-6">
              <img src={ASSETS.membersRadial} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
              <img src={ASSETS.membersImg} alt="Members" className="relative w-full h-auto rounded-2xl" />
            </div>
          </div>
          <div className="order-2">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5 leading-tight">
              Browse thousands of members for free
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              There's nothing more satisfying than finding that one person who shares all the same interests as you do. We provide you with the tool to be able to do it!
            </p>
          </div>
        </div>

        {/* Row 2 - Chat with girls */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-24">
          <div className="order-2 md:order-1">
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5 leading-tight">
              Chat with attractive local girls
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed">
              Chat with beautiful girls from all over the country. Find your next date without even leaving home!
            </p>
          </div>
          <div className="order-1 md:order-2 relative card-hover">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-pink-50 to-purple-50 p-6 flex items-center justify-center">
              <img src={ASSETS.find1} alt="Chat" className="relative w-full h-auto max-w-md rounded-2xl" />
            </div>
          </div>
        </div>

        {/* Row 3 - Encounter */}
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="relative card-hover">
            <div className="relative rounded-3xl overflow-hidden bg-gradient-to-br from-pink-50 to-purple-50 p-6">
              <img src={ASSETS.find2} alt="Match" className="relative w-full h-auto rounded-2xl" />
            </div>
          </div>
          <div>
            <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-5 leading-tight">
              Encounter your best match
            </h3>
            <p className="text-gray-600 text-lg leading-relaxed mb-7">
              Many singles nowadays find it hard to find happiness, this feeling increases the longer it has been since dating someone else. There is nothing appealing about being alone, only a loss of excitement and stimulation. Flirty will give you the ability to encounter the perfect match for you.
            </p>
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className="px-8 h-12 bg-fnl-pink hover:bg-fnl-pink text-white font-semibold rounded-full btn-shadow-pink"
            >
              Get Started Now
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
